export default __webpack_public_path__ + "static/c3-3b0ced0dd49075f3f5607761c9d6bf3c.png";